function validatePhoneNumber(phone_input, callback){
	// set endpoint and your access key
	var access_key = '49ee140e25cffb4f73209cfb4f307763';
	var phone_number = phone_input.value;

	if(!phone_number || phone_number.length == 0){
		return false;
	}

	// verify phone number via AJAX call
	$.ajax({
	    url: 'https://apilayer.net/api/validate?access_key=' + access_key + '&number=' + phone_number + '&country_code=US&format=0',   
	    dataType: 'jsonp',
	    success: function(json) {
	    	console.log(json);
		    // Access and use your preferred validation result objects
		    // console.log(json.valid);
		    // console.log(json.country_code);
		    // console.log(json.carrier);

		    // Check only US numbers
		    if(json.country_code == 'US'){
		    	console.log('Phone number is valid and located in US');

		    	if(typeof callback === "function"){
		    		callback();
		    		console.log('Callback finished');
		    	}

		    	jQuery(phone_input).attr('data-validated', true);
		    	
		    	return json.valid;
		    }else{
		    	alert('Looks like your phone number has an incorrect format or you are located outside of the US. If you are located in the US, please double check your phone number or contact us another way.');
		    	phone_input.value = '';
		    	jQuery(phone_input).attr('data-validated', false);
		    	return false;
		    }
	    }
	});
}


function centerPopup(){
		jQuery('.popupWindow').each(function(){
			var popup = jQuery(this);

			var currentPopupState = popup.parent().css('display');
			popup.parent().css({ position: "absolute", visibility: "hidden", display: "block" });
			var popupCurrentWidth = popup.outerWidth();
			popup.parent().css({ position: "", visibility: "visible", display: "" });
			var newMargin = popupCurrentWidth / 2; 
			popup.css('margin-left', '-' + newMargin + 'px');
			popup.parent().css('display', currentPopupState );
		});
	}

jQuery(document).ready(function(){	
	console.log('ready');

	


	// var bannerHeight = jQuery('.home_banner_image').outerHeight();
	// jQuery('.video-presentation').css('height', bannerHeight);

	/* Home Page Banner */
	// jQuery(window).resize(function(){
	// 	var bannerHeight = jQuery('.home_banner_image').outerHeight();
	// 	jQuery('.video-presentation').css('height', bannerHeight);
	// });


	//Apple Touch Fix
	var isTouch = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0));
	if(isTouch == true & window.innerWidth < 768){
		jQuery('body').css('cursor', 'pointer');

		//Apple Safari Fix
		// jQuery('#main-menu ul li a').click(function(e){
		// 	// jQuery(this).addClass('hoverLink');
		// 	// var href = jQuery(this).attr('href');
		// 	// setTimeout(function(){window.location.href = href}, 300);
		// });
	}else{
		// jQuery('#main-menu ul li a').click(function(e){
		// 	// var href = jQuery(this).attr('href');
		// 	// window.location.href = href;
		// });
	}

	//Dropdown Fixes
	jQuery('.dropdown li a').click(function(){
		var currentDropdownValue = jQuery(this).text();
		jQuery(this).parents('.dropdown').children('.dropdown-toggle').children('.currentDropdownText').text(currentDropdownValue);
	});

	//Tips Fix

	jQuery('.tooltip-button').on('touchstart',function(e){
		e.stopPropagation();
		e.preventDefault();
	    var isSecondClick = jQuery(this).hasClass('opened-tip');

	    if(isSecondClick == true){
	       jQuery(this).mouseout();
	    }else{
	       closeAllOpenedTips();
	       jQuery(this).mouseenter();
	       jQuery(this).addClass('opened-tip');
	    } 

	    jQuery(this).mouseleave(function(){
	    	jQuery(this).removeClass('opened-tip');
	    });   
	});

	jQuery('body').click(function(){
		closeAllOpenedTips();
	});

	function closeAllOpenedTips(){
		jQuery('.opened-tip').each(function(){
			jQuery(this).removeClass('opened-tip');
			jQuery(this).mouseout();
		});
	}
	
	
	/* Hide Popups */
		
			jQuery('.popupBackground').click(function(){
				//Apple Fixed Input Fix Initial State (Popup)
				jQuery('.ziphearing_content').css('position', 'relative');

				//Reset initial settings
				jQuery('.yes-or-no-wrapper').css('left', '0px');
				jQuery('#bummer-brand-popup .search-wrapper').css('left', '0px');

				jQuery(this).fadeOut(500);

				//Hide message 'Providers not found'
				setTimeout(function(){
					jQuery('.bummer-not-dound-wrapper').hide();
				}, 800);

				jQuery('body').css('overflow', 'visible');
			});

			jQuery('.popupWindow').click(function(event){
				event.stopPropagation();
			});

			jQuery('.closeButton').click(function(){
				//Apple Fixed Input Fix Initial State (Popup)
				jQuery('.ziphearing_content').css('position', 'relative');

				//Reset initial settings
				jQuery('.yes-or-no-wrapper').css('left', '0px');
				jQuery('#bummer-brand-popup .search-wrapper').css('left', '0px');

				jQuery('.popupBackground').fadeOut(500);

				//Hide message 'Providers not found'
				setTimeout(function(){
					jQuery('.bummer-not-dound-wrapper').hide();
				}, 800);

				jQuery('body').css('overflow', 'visible');
			});


	


	jQuery(window).resize(function(){
		centerPopup();
	});

	centerPopup();
	
	/* Map Overlay Fix */

	var mapOverlay = jQuery('.map-overlay');

	jQuery('html').click(function(){
		showMapOverlay();
	});

	jQuery('.home-page-map').click(function(){
		event.stopPropagation();
	})

	mapOverlay.click(function(event){
		event.stopPropagation();
		hideMapOverlay();
	})

	function showMapOverlay(){
		mapOverlay.fadeIn(200);
	}

	function hideMapOverlay(){
		mapOverlay.fadeOut(200);
	}


	/* Mobile Menu Fixes */
	jQuery('#ziphearing-mobile-trigger').click(function(){
		jQuery('#zn-res-menu').addClass('zn-menu-visible');
	});	

	jQuery(".btn-slide").click(function(){
        jQuery(this).toggleClass("active-panel"); 
        return false;
    });


	// var bannerHeight = jQuery('.home_banner_image').outerHeight();
	// jQuery('.video-presentation').css('height', bannerHeight);

	

	//Image protect

	jQuery('img').bind('contextmenu', function(e) {
    	return false;
	}); 
	
	$('img').on('dragstart', function(event) { event.preventDefault(); });


	//Apple Validate Fix
	function validateCheck(form){
		$(ref).each(function(){
			if ( $(this).val() == '' ){
				jQuery(this).addClass('form-control-fail');
				jQuery('body').scrollTop(jQuery(this).offset().top - 5);
				$(this).focus();
				e.preventDefault();
				return false;
			}
		});  
		return true;
	}

	jQuery('input').change(function(){
		if(jQuery(this).val != ""){
			jQuery(this).removeClass('form-control-fail');
		}
	});

	//Footer Apple Fix
	jQuery('#mc-embedded-subscribe-form').submit(function(e){
		var userType = jQuery('#mce-EMAIL').val();
		if(isValidEmailAddress(userType) == false){
			e.preventDefault();
			jQuery('#mce-EMAIL').addClass('form-control-fail');
		}
        
    });

    function isValidEmailAddress(emailAddress) {
        var pattern = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i);
        return pattern.test(emailAddress);
    };


	/* Count Prices */

	//setTimeout(countPrices, 2000);

	/*function countPrices(){
		jQuery('.price-count').prop('number', 3999).animateNumber({number: 2990}, 4000);
	}*/


});

// Arrow In Toogle Box Fix
var a = true;

jQuery('.panel-heading').click(function(){
	if(a == true){
		a = false;
		jQuery(this).find('a').click();
		a = true;
	}

	jQuery(this).removeClass();
	jQuery(this).addClass('panel-heading');
	if(jQuery(this).find('a').hasClass('collapsed') == false){
		jQuery(this).addClass('openedBlock');
	}
});

//IE Fixes

//Line Height Fix
if (!!navigator.userAgent.match(/Trident\/7\./)){
	// alert('ie detect');
	jQuery('#zip-code-popup .search').addClass('line-height-zero');
	jQuery('.hearing-aid-pricelist .gray-section .filters-wrapper .search-filter #search-aid').addClass('line-height-zero');
}else{
	// alert('not ie');
}


function go_to_details(url,event) {
    event.preventDefault();
    event.stopPropagation();
    setTimeout(function(){document.location.href = url},200);
}


jQuery(document).ready(function(){
	centerPopup();
});